import React from 'react'
import { Field, reduxForm } from 'redux-form'
import styles from './styles.css'
import { renderSelectField, renderInputField } from 'components/FormFields'
import { Button } from 'components/Button'
import states from 'lib/states'
import normalizers from 'lib/field/normalizers'
import formatters from 'lib/formatters'
import { STATUS_OPTIONS } from 'lib/constants'
import { filterEmptyValues } from './subaccountUtils'

type Props = {
  handleSubmit: Function,
  submitting: boolean,
  pristine: boolean,
  onCancel: Function,
  initialValues: Object,
  subaccount: Object,
  accountNumber: string,
  subnumber: string,
  onSuccess: Function,
  onSubmit?: Function,
}

const VehicleForm = (props: Props) => {
  const { handleSubmit, submitting, pristine, onCancel, change } = props

  const onSubmit = (values) => {
    const filteredValues = filterEmptyValues({
      ...values,
      vin: values.vin ? values.vin.toUpperCase() : values.vin,
      purchase_amount: normalizers.float(values.purchase_amount || ''),
    })

    return props.onSubmit ? props.onSubmit(filteredValues) : Promise.resolve()
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className={styles.contentContainer}>
        <div className={styles.formRow}>
          <div className={styles.formSection}>
            <section data-active={true} className={styles.collapseRef}>
              <div className={styles.titleSection}>
                <div className={styles.title}>
                  <h5>Primary Garage Location</h5>
                </div>
              </div>
              <div className={styles.docsWrapper}>
                <Field name="primary_garage_street_1" type="text" component={renderInputField} label="Address Line 1" />
                <Field name="primary_garage_street_2" type="text" component={renderInputField} label="Address Line 2 (Optional)" />
                <div className={styles.formRow}>
                  <div className={styles.formSection} style={{ flex: '3' }}>
                    <Field name="primary_garage_city" type="text" component={renderInputField} label="City" />
                  </div>
                  <div className={styles.formSection} style={{ flex: '2' }}>
                    <Field name="primary_garage_state" component={renderSelectField} label="State" options={states} placeholderText="State" />
                  </div>
                </div>
                <div style={{ width: '50%' }}>
                  <Field name="primary_garage_zip" type="text" component={renderInputField} label="Zip" />
                </div>
              </div>
            </section>

            <section data-active={true} className={styles.collapseRef}>
              <div className={styles.titleSection}>
                <div className={styles.title}>
                  <h5>Lien Information</h5>
                </div>
              </div>
              <div className={styles.docsWrapper}>
                <div className={styles.formRow}>
                  <div className={styles.formSection}>
                    <Field name="lien_date" component={renderInputField} type="date" label="Lien Date" placeholder="MM/DD/YYYY" />
                  </div>
                  <div className={styles.formSection}>
                    <Field name="lien_state" component={renderSelectField} label="State of Lien" options={states} placeholderText="State" />
                  </div>
                </div>
                <Field name="lien_holder" type="text" component={renderInputField} label="Lienholder" />
                <Field name="lien_id" type="text" component={renderInputField} label="Lien ID" />
              </div>
            </section>
          </div>

          <div className={styles.formSection}>
            <section data-active={true} className={styles.collapseRef}>
              <div className={styles.titleSection}>
                <div className={styles.title}>
                  <h5>Subaccount Status</h5>
                </div>
              </div>
              <div className={styles.docsWrapper}>
                <Field name="status" component={renderSelectField} label="Current Status" options={STATUS_OPTIONS} placeholder="Active" />
              </div>
            </section>

            <section data-active={true} className={styles.collapseRef}>
              <div className={styles.titleSection}>
                <div className={styles.title}>
                  <h5>Vehicle Information</h5>
                </div>
              </div>
              <div className={styles.docsWrapper}>
                <div className={styles.formRow}>
                  <div className={styles.formSection}>
                    <Field name="purchase_date" component={renderInputField} type="date" label="Purchase Date" placeholder="MM/DD/YYYY" />
                  </div>
                  <div className={styles.formSection}>
                    <Field
                      name="purchase_amount"
                      type="text"
                      component={renderInputField}
                      label="Purchase Amount"
                      placeholder="ex: 42,300.00"
                      format={normalizers.withCommas}
                      normalize={normalizers.float}
                      onBlur={(e) => {
                        e.preventDefault()
                        change('purchase_amount', formatters.currency(normalizers.float(e.target.value)))
                      }}
                    />
                  </div>
                </div>
                <div className={styles.formRow}>
                  <div className={styles.formSection}>
                    <Field name="make" type="text" component={renderInputField} label="Make" />
                  </div>
                  <div className={styles.formSection}>
                    <Field name="model" type="text" component={renderInputField} label="Model" />
                  </div>
                </div>
                <div className={styles.formRow}>
                  <div className={styles.formSection}>
                    <Field name="year" type="text" component={renderInputField} label="Year" />
                  </div>
                  <div className={styles.formSection}>
                    <Field name="trim" type="text" component={renderInputField} label="Trim" />
                  </div>
                </div>
                <div className={styles.formRow}>
                  <div className={styles.formSection}>
                    <Field name="vin" type="text" component={renderInputField} label="VIN" />
                  </div>
                  <div className={styles.formSection}>
                    <Field
                      name="mileage"
                      type="text"
                      component={renderInputField}
                      label="Mileage"
                      format={(value) => normalizers.withCommas(value, true)}
                      normalize={(value) => String(value ?? '').replace(/\D/g, '')}
                    />
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
      <div className={styles.row}>
        <Button size="default" color="red" label="Cancel" onClick={onCancel} type="button" disabled={submitting} />
        <Button size="default" color="blue" label="Save Changes" type="submit" disabled={pristine || submitting} />
      </div>
    </form>
  )
}

export default reduxForm({
  form: 'vehicleSubaccountForm',
  enableReinitialize: true,
})(VehicleForm)
